import React from 'react';
import { Col, Container, Row } from 'reactstrap';

const Testi = ({}) => {
  return (
    <React.Fragment>
      <section className="section pt-0">
        <Container className="px-4 px-md-3 px-lg-0">
          <Row className="mt-md-5 pt-md-3 mt-4 pt-2 mt-sm-0 pt-sm-0 justify-content-center">
            <Col xs="12" className="text-center">
              <div className="section-title">
                <h4 className="title mb-4">Start Building Your Vocabulary Today</h4>
                <p className="text-muted para-desc mx-auto">
                  <span className="text-primary fw-bold">HighVocab</span> is free
                  to install. Add it to your browser and start saving words from
                  the very first page you visit.
                </p>
                <div className="mt-4 pt-2 d-flex flex-column flex-sm-row justify-content-center align-items-center gap-3">
                  <a
                    href="https://chrome.google.com/webstore/detail/highvocab-vocabulary-buil/nmalijlbcckplnamalenpdaafacfeemd?hl=en"
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-primary w-100 w-sm-auto"
                    style={{ maxWidth: 320 }}
                  >
                    Add to Chrome — It's Free <i className="mdi mdi-arrow-right"></i>
                  </a>
                  <a
                    href="https://microsoftedge.microsoft.com/addons/detail/highvocab-vocabulary-bui/dfpolnmicooilcndegandafkmooecmei"
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-outline-primary w-100 w-sm-auto"
                    style={{ maxWidth: 320 }}
                  >
                    Install on Edge
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};
export default Testi;
